import axios from 'axios'
import { getToken,removeToken } from '@/utils/auth'

import router from "@/router/index"
const httpclient = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 25000 // request timeout
})

httpclient.interceptors.request.use(
  config => {
    if(getToken()){
      config.headers['Authorization'] = getToken()
    }
    return config
  },
  
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
httpclient.interceptors.response.use(
  response =>{
    try {
      const res = response.data
      if(res.code === 401){
        removeToken()
        router.push("/login")
      }
      return res
    } catch (error) {
      console.log(error)
    }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default httpclient
